export const screenRoutes = {
    registration: "/registration",
    verifyEmail: "/verify-email",
    retry: "/retry",
    welcome: "/welcome",
    termsApproval: "/terms-approval",
    unauthorized: "/unauthorized",
};
